import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Loader from 'react-loader-advanced';
import { contextType } from 'types';

import trim from 'lodash/trim';

import { FormGroupField } from 'components/Form';

import InspectButton from 'components/InspectButton';
import InspectLoader from 'components/InspectLoader';
import InspectFooter from 'components/InspectFooter';

import ContextBlocksList from './components/ContextBlocksList';

import './style.scss';

export class ContextInspectForm extends Component {
  static propTypes = {
    isDirty: PropTypes.bool.isRequired,
    isInvalid: PropTypes.bool.isRequired,
    partialExport: PropTypes.func.isRequired,
    context: contextType,
    isLoading: PropTypes.bool,
    isUpdating: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    const {
      context: { id },
    } = this.props;
    if (id !== prevProps.context.id) {
      this.input.focus();
    }
  }

  handleRef = el => {
    this.input = el;
  };

  handlePartialExport = () => {
    const {
      context: { id, name },
      partialExport,
    } = this.props;
    partialExport(`context-${name}`, [id]);
  };

  render() {
    const { context, isDirty, isInvalid, isLoading, isUpdating } = this.props;

    return (
      <Loader
        backgroundStyle={{ backgroundColor: 'rgba(255, 255, 255, .67)' }}
        foregroundStyle={{ color: '#555555' }}
        message="Updating..."
        show={isUpdating}
        styleName="edit-context-loader"
      >
        <div styleName="edit-context-form">
          <InspectLoader isLoading={isLoading} />
          <Field
            autoFocus
            autoComplete="foo-boo-foo-boo"
            component={FormGroupField}
            data-text="inspect-context-name"
            disabled={context.archived}
            label="CONTEXT NAME"
            name="name"
            normalize={trim}
            // FIXME: That's the fix since Chrome warning inputs without
            // this attr and there is no way to disable it, autoComplete='off' doest work
            placeholder="Please type a name for the context"
            type="text"
            onInputRef={this.handleRef}
          />
          <ContextBlocksList
            isDisabled={context.archived}
            items={context.blocks}
          />
          <InspectFooter>
            <InspectButton
              isFooter
              data-test="inspect-context-export-button"
              onClick={this.handlePartialExport}
            >
              Export
            </InspectButton>
            <InspectButton
              isFooter
              isSave
              data-test="inspect-context-save-button"
              disabled={isLoading || isUpdating || !isDirty || isInvalid}
              type="submit"
            >
              Save
            </InspectButton>
          </InspectFooter>
        </div>
      </Loader>
    );
  }
}

export default ContextInspectForm;
